/**
 * VotoValePor — "🗳️ Tu voto vale por 3 · 1 tuyo + 2 por poder" (#10).
 *
 * Una sola línea corta para quien vota por más de una unidad (propias y/o por
 * poder). Con una sola unidad no se muestra nada. El detalle (qué unidades,
 * con torre) va en el tooltip para no llenar la pantalla. Los números vienen
 * de my-status (`voto`), calculados con la misma regla que el voto real.
 * Va sobre fondo de color de acento (hero del panel y cabecera del VoteModal).
 */
import styles from './VotoValePor.module.css';

// variante: 'sala' (hero del panel del propietario) | 'modal' (cabecera del VoteModal); sin variante = la base.
export default function VotoValePor({ voto, variante }) {
  if (!voto || voto.total <= 1) return null;
  const { total, propias, por_poder: poder, unidades = [] } = voto;

  let detalle;
  if (propias && poder) detalle = `${propias} ${propias === 1 ? 'tuyo' : 'tuyos'} + ${poder} por poder`;
  else if (poder)       detalle = 'por poder';
  else                  detalle = `tus ${propias} unidades`;

  const tooltip = 'Votas por: ' + unidades
    .map(u => u.por_poder ? `${u.etiqueta} (poder)` : u.etiqueta)
    .join(', ');

  return (
    <span title={tooltip} className={`${styles.valePor} ${variante ? styles[variante] : ''}`}>
      <span aria-hidden="true">🗳️</span>
      <span><strong>Tu voto vale por {total}</strong> · {detalle}</span>
    </span>
  );
}
